<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <circle
        cx="17.444"
        cy="12"
        r="1.556"
        fill="inherit"
        stroke="none"
        transform="rotate(90 17.444 12)"
      />
      <circle cx="12" cy="12" r="1.556" fill="inherit" stroke="none" transform="rotate(90 12 12)" />
      <circle
        cx="6.556"
        cy="12"
        r="1.556"
        fill="inherit"
        stroke="none"
        transform="rotate(90 6.556 12)"
      />
    </svg>
  </span>
</template>
